/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface GenerateFileRequest { 
    name: string;
    content_type: string;
    size: number;
    /**
     * Option to create read:public files from the start.
     */
    is_public: boolean;
    /**
     * Optional, a reference to a folder. If missing, stored in the root folder.
     */
    folder_descriptor_id?: string;
}